import React from 'react';
import { ShieldCheck, Users, ArrowRight } from 'lucide-react';
export function TrustSection() {
  return <section className="relative w-full bg-gradient-to-b from-black to-slate-950 py-20 md:py-32 font-['Inter',_sans-serif] overflow-hidden border-t border-amber-900/20" data-id="element-62">
      {/* Subtle background glow */}
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-amber-600/5 rounded-full blur-[100px] pointer-events-none" data-id="element-63"></div>
      <div className="absolute top-1/2 left-0 -translate-y-1/2 w-[300px] h-[300px] bg-yellow-500/5 rounded-full blur-[80px] pointer-events-none" data-id="element-64"></div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-65">
        <div className="max-w-6xl mx-auto bg-slate-900/40 border border-amber-500/10 rounded-3xl p-8 md:p-12 backdrop-blur-sm shadow-2xl" data-id="element-66">
          <div className="flex flex-col md:flex-row items-center gap-12 md:gap-16" data-id="element-67">
            {/* Image Column */}
            <div className="w-full md:w-1/2 flex justify-center" data-id="element-68">
              <div className="relative w-full max-w-md" data-id="element-69">
                {/* Decorative glow behind image */}
                <div className="absolute -inset-2 bg-gradient-to-tr from-amber-500/20 to-yellow-300/10 rounded-2xl blur-xl opacity-50" data-id="element-70"></div>

                <img src="https://cdn.magicpatterns.com/uploads/n8zYQ3S9NkPtizgsjm9cVX/Designer_(2).png" alt="Pago exitoso en teléfono móvil" className="relative w-full h-auto object-cover rounded-2xl border border-amber-500/20 shadow-[0_0_30px_rgba(0,0,0,0.5)]" data-id="element-71" />

                {/* Floating badge */}
                <div className="absolute -bottom-6 -right-6 md:-right-8 bg-slate-900 border border-amber-500/30 rounded-xl p-4 shadow-xl flex items-center gap-3 animate-float" style={{
                animationDuration: '4s'
              }} data-id="element-72">
                  <div className="bg-amber-500/20 p-2 rounded-full" data-id="element-73">
                    <Users className="w-6 h-6 text-amber-400" data-id="element-74" />
                  </div>
                  <div data-id="element-75">
                    <p className="text-white font-bold text-sm" data-id="element-76">
                      +450 personas
                    </p>
                    <p className="text-amber-400 text-xs" data-id="element-77">este mes</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Text Column */}
            <div className="w-full md:w-1/2 flex flex-col items-center md:items-start text-center md:text-left space-y-8 mt-8 md:mt-0" data-id="element-78">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber-500/10 border border-amber-500/20 text-amber-400 text-sm font-semibold tracking-wide uppercase" data-id="element-79">
                <ShieldCheck className="w-4 h-4" data-id="element-80" />
                <span data-id="element-81">Garantía 100% Libre de Riesgo</span>
              </div>

              <h2 className="font-['Playfair_Display',_serif] text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight" data-id="element-82">
                Tu transformación{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-200 to-amber-500" data-id="element-83">
                  garantizada.
                </span>{' '}
                🛡️
              </h2>

              <div className="space-y-4 text-gray-300 text-lg leading-relaxed" data-id="element-84">
                <p data-id="element-85">
                  <strong className="text-white font-semibold" data-id="element-86">
                    +450 personas
                  </strong>{' '}
                  ya activaron su frecuencia Zenith este mes.
                </p>
                <p data-id="element-87">
                  Si tras los 7 días no sientes un cambio profundo en tu
                  mentalidad y tus oportunidades, te devolvemos tus $3.20{' '}
                  <span className="text-amber-400 font-medium italic" data-id="element-88">
                    sin preguntas
                  </span>
                  .
                </p>
              </div>

              <div className="w-full pt-6" data-id="element-89">
                <a href="https://protocolzenith.com/products/protocolo-zenith-codigo-3-6-9-edicion-7-dias?utm_source=copyToPasteBoard&utm_medium=product-links&utm_content=web" target="_blank" rel="noopener noreferrer" className="w-full px-6 py-5 rounded-xl bg-gradient-to-r from-amber-400 to-amber-600 text-gray-900 text-base md:text-lg font-bold uppercase tracking-wide hover:scale-[1.02] transition-all duration-300 cursor-pointer focus:outline-none focus:ring-4 focus:ring-amber-400/50 shadow-[0_0_20px_rgba(245,158,11,0.3)] hover:shadow-[0_0_30px_rgba(245,158,11,0.5)] flex items-center justify-center gap-2 group no-underline" aria-label="Descargar el protocolo flash ahora" data-id="element-90">
                  DESCARGA EL PROTOCOLO FLASH AHORA ($3.20) 📥
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-91" />
                </a>

                <p className="text-center text-gray-500 text-xs mt-4 flex items-center justify-center gap-1" data-id="element-92">
                  <ShieldCheck className="w-3 h-3" data-id="element-93" /> Pago 100% seguro y
                  encriptado
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}